export { default as AdaRedirectButton } from './src/ada-redirect-button';
